export const collectLocations = (subscriptions: any[]) => {
  const locationSet = new Set<string>();

  subscriptions
    .flatMap((s) => s.locations ?? [])
    .forEach((location) => {
      const { city = "-", street = "-", number = "-" } = location?.address ?? {};
      const label = `${city.toLowerCase()} (${street.toLowerCase()} ${number})`;
      locationSet.add(label);
    });

  return Array.from(locationSet).sort();
};
